module.exports = __webpack_public_path__ + "assets/img/ability37.428ca4d4.png";